import React from "react";
import Home from "./Home";
import { Button, Col, Modal, Row } from "react-materialize";
import { Link } from "react-router-dom";
import { API_LANDING, BASE_URL } from "../../Util";
import { trans } from "../../Lang";
import $ from "jquery";
import VideoPlayer from "./VideoPlayer";
import BlogSection from "./BlogSection";

class Landing extends Home {
  constructor(props) {
    super(props);
    this.state = {
      media_url: "https://www.youtube.com/watch?v=lZwouwdH3Gg",
      title: "SMILE E-Learning",
      description: trans.vaccine,
    };
  }

  handleLoadData = (e) => {
    $.get(API_LANDING).then((data) => {
      this.setState(data.payload);
    });
  };

  render() {
    let announcement = this.state.announcement;

    return (
      <div>
        <div className="bg-white pad-xl">
          <div className="container center fadeIn wow">
            <Row>
              <img
                className="hide-on-med-and-down"
                id="logo-horizontal"
                src={
                  BASE_URL + "/img/white-label/logo/SMILE_Logo-Horisontal2.png"
                }
                alt=""
              />
              <img
                className="show-on-small"
                id="logo-vertikal"
                src={BASE_URL + "/img/white-label/logo/SMILE_logo_vertikal.png"}
                alt="logo smile"
                style={{ maxWidth: "50%" }}
              />
            </Row>
          </div>
        </div>

        <div className="video-banner bg-blue">
          <Row className="container mb-0">
            <Col className="mb-m fadeInLeft wow" s={12} m={6}>
              <div>
                <VideoPlayer
                  width="100%"
                  height="75%"
                  url={this.state.media_url}
                />
              </div>
            </Col>
            <Col className="fadeIn wow" s={12} m={6}>
              <h5
                className="font-white font-light"
                dangerouslySetInnerHTML={{ __html: trans.vaccine }}
              ></h5>
            </Col>
          </Row>
        </div>

        <div className="bg-white pad-l">
          <div className="container center fadeIn wow">
            <h1 className="keunggulan-smile mb-m">
              <b>{trans.smile_benefits}</b>
            </h1>
            <Row className="center keunggulan" style={{ textAlign: "center" }}>
              <Col className="pad-s" m={2} s={12}>
                <img
                  className="mb-s icon-home"
                  src={
                    BASE_URL +
                    "/img/white-label/icons/Ikon_Keunggulan-SMILE_1.png"
                  }
                />
                <h5 className="font-blue">{trans.inventory}</h5>
                <p>{trans.doses}</p>
              </Col>
              <Col className="pad-s" m={2} s={12}>
                <img
                  className="mb-s icon-home"
                  src={
                    BASE_URL +
                    "/img/white-label/icons/Ikon_Keunggulan-SMILE_2.png"
                  }
                />
                <h5 className="font-blue">{trans.distribution}</h5>
                <p>{trans.tracking}</p>
              </Col>
              <Col className="pad-s" m={2} s={12}>
                <img
                  className="mb-s icon-home"
                  src={
                    BASE_URL +
                    "/img/white-label/icons/Ikon_Keunggulan-SMILE_3.png"
                  }
                />
                <h5 className="font-blue">{trans.monitoring_title}</h5>
                <p>{trans.monitoring_body}</p>
              </Col>
              <Col className="pad-s" m={2} s={12}>
                <img
                  className="mb-s icon-home"
                  src={
                    BASE_URL +
                    "/img/white-label/icons/Ikon_Keunggulan-SMILE_4.png"
                  }
                />
                <h5 className="font-blue">{trans.asset}</h5>
                <p>{trans.asset_data}</p>
              </Col>
              <Col className="pad-s" m={2} s={12}>
                <img
                  className="mb-s icon-home"
                  src={
                    BASE_URL +
                    "/img/white-label/icons/Ikon_Keunggulan-SMILE_5.png"
                  }
                />
                <h5 className="font-blue">{trans.report}</h5>
                <p>{trans.data_center}</p>
              </Col>
            </Row>
          </div>
        </div>

        <Row className="mb-0">
          <Col className="pad-xl-l bg-testimoni-left height-450" s={12} l={6}>
            <div className="testi width-500 fadeInLeft wow">
              <img
                src={BASE_URL + "/img/white-label/icons/quote_left.png"}
                alt=""
              />

              <p>{trans.testi_1_content}</p>
              <div className="name">Dr. Hj. Yana Yanti Suleman, SH</div>
              <div className="status">{trans.testi_1_position}</div>
            </div>
          </Col>
          <Col className="pad-xl-l bg-testimoni-right height-450" s={12} l={6}>
            <div className="testi width-500 fadeInLeft wow">
              <img
                src={BASE_URL + "/img/white-label/icons/quote_left.png"}
                alt=""
              />
              <p>{trans.testi_2_content}</p>
              <div className="name">Enalia Rostika</div>
              <div className="status">{trans.testi_2_position}</div>
            </div>
          </Col>
        </Row>

        <div className="bg-white">
          <a href="/publication">
            <div className="container pad-m">
              <Row>
                <Col l={3} m={3} s={12} className="height-300 banner-image-1">
                  <img
                    src={BASE_URL + "/img/white-label/pictures/image25.png"}
                    alt=""
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col className=" height-300 center-m" l={6} m={6} s={12}>
                  <div className="pad-xl" style={{ textAlign: "center" }}>
                    <h3 className="banner-title font-blue mb-s">
                      {trans.publication}
                    </h3>
                    <div className="banner-text mb-s font-blue">
                      {trans.share}
                    </div>
                  </div>
                </Col>
                <Col l={3} m={3} s={12} className="height-300 banner-image-2">
                  <img
                    src={BASE_URL + "/img/white-label/pictures/image26.png"}
                    alt=""
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>
            </div>
          </a>
        </div>

        <div className="bg-lightblue">
          <a href="/course/catalog">
            <div className="container">
              <Row className="banner-bottom">
                <Col l={4} s={12}>
                  <img
                    className="banner-image-3"
                    src={BASE_URL + "/img/white-label/pictures/image24.png"}
                    alt=""
                  />
                </Col>
                <Col className="offset-l1" l={7} s={12}>
                  <h3 className="banner-title font-blue mb-s mt-m">
                    {trans.online_course}
                  </h3>
                  <div
                    className="banner-text  mb-s font-blue"
                    style={{ textAlign: "left" }}
                    dangerouslySetInnerHTML={{
                      __html: trans.course_intent,
                    }}
                  ></div>
                  <div style={{ margin: "30px 0", fontWeight: "bold" }}>
                    <div
                      style={{
                        display: "inline-block",
                        background: "white",
                        padding: "5px 15px",
                      }}
                    >
                      <span style={{ color: "#22A5DB", fontSize: "3em" }}>
                        {this.state.total_students}
                      </span>
                      <span
                        style={{
                          color: "black",
                          fontSize: 18,
                          lineHeight: "22px",
                          marginLeft: 10,
                          verticalAlign: "super",
                        }}
                      >
                        Peserta Terdaftar Kursus Online SMILE
                      </span>
                    </div>
                  </div>
                  <Link to="/course/catalog">
                    <button className="blueButton1 mr-s">
                      <span>
                        {/* <img className="waIcon" src={BASE_URL + "/img/white-label/icons/question.png"}/> */}
                        {trans.browse_courses}
                      </span>
                    </button>
                  </Link>
                </Col>
              </Row>
            </div>
          </a>
        </div>

        <BlogSection />

        <div className="bg-white pad-xl">
          <div className="container">
            <Row>
              <Col s={12} m={6} l={6}>
                <div>
                  <VideoPlayer
                    width="100%"
                    height="75%"
                    url="https://www.youtube.com/watch?v=lZwouwdH3Gg"
                  />
                </div>
              </Col>
              <Col s={12} m={1} l={1}></Col>
              <Col s={12} m={5} l={5}>
                <div className="pelatihanSmile">
                  <b>{trans.training_docs}</b>
                </div>
                <div className="pelatihanSmileContent">{trans.video_docs}</div>
                <a
                  href="https://www.youtube.com/channel/UCqY2o4HL05XCpYoDZis4w-g"
                  className="youtube-link"
                >
                  {trans.youtube}
                </a>
              </Col>
            </Row>
            <Row>
              <div className="center">
                <Link to="/faq">
                  <button className="blueButton1 mr-s">
                    <span>
                      {/* <img className="waIcon" src={BASE_URL + "/img/white-label/icons/question.png"}/> */}
                      {trans.faq}
                    </span>
                  </button>
                </Link>
                <Link to="/contacts">
                  <button className="blueButton1 ml-s">
                    <span>
                      {/* <img className="waIcon" src={BASE_URL + "/img/white-label/icons/whatsapp.png"}/> */}
                      {trans.contact_us}
                    </span>
                  </button>
                </Link>
              </div>
            </Row>
          </div>
        </div>

        {announcement && (
          <Modal
            trigger={
              <Button id="announcement-btn" className="hide">
                SUBMIT
              </Button>
            }
          >
            <div className="center almost-full">
              <img
                className="mb-s"
                src={BASE_URL + "/img/ic_announcement.png"}
              />
              <h4 className="font-light">{announcement.title}</h4>
              {announcement.image_url && (
                <img className="mb-s height-150" src={announcement.image_url} />
              )}
              <div className="mb-m">{announcement.detail}</div>
              {!announcement.info_url && (
                <a className="btn modal-close capitalize btn-outline">Oke</a>
              )}
              {announcement.info_url && (
                <a
                  href={announcement.info_url}
                  target="_blank"
                  className="btn modal-close capitalize btn-outline"
                >
                  Lebih Lanjut
                </a>
              )}
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Public/Home/Landing.js